import { useFeatures, useSpli, useLogout } from "@spli/app-logic";
import { Link } from "react-router-dom";
import { SpliLogo } from "./SpliLogo.js";

export function AppHeader() {
  const { user } = useSpli();
  const features = useFeatures();
  const logout = useLogout();

  return (
    <header className="app-header">
      <div className="app-header__inner">
        {/*
          バーではロゴタイプだけを出す。アイコンを並べると、この高さでは
          絵柄が潰れて何か分からなくなるため (アイコンはトップのヒーローに置く)。
        */}
        <Link to="/" className="app-header__brand" aria-label="スプリ トップへ">
          <SpliLogo className="app-header__logo" height={22} />
        </Link>

        <nav className="app-header__nav">
          {user ? (
            <>
              <Link to="/history">履歴</Link>
              {features.payoutAccounts && <Link to="/account">受取先</Link>}
              {/*
                表示名はメールアドレスから自動で作るため、長くなることがある。
                幅を取りすぎてロゴやボタンを押し出さないよう省略する。
              */}
              <span className="muted app-header__user" title={user.displayName}>
                {user.displayName}
              </span>
              <button
                type="button"
                className="button button--ghost button--small"
                onClick={() => logout.mutate()}
              >
                ログアウト
              </button>
            </>
          ) : (
            <Link to="/login">ログイン</Link>
          )}
        </nav>
      </div>
    </header>
  );
}
